import { render, staticRenderFns } from "./RiderDashboard.vue?vue&type=template&id=c8a3ae96&scoped=true"
import script from "./RiderDashboard.vue?vue&type=script&lang=js"
export * from "./RiderDashboard.vue?vue&type=script&lang=js"
import style0 from "./RiderDashboard.vue?vue&type=style&index=0&id=c8a3ae96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a3ae96",
  null
  
)

export default component.exports